const API = `${process.env.REACT_APP_BACKEND_URL}/api/publishing`;

async function req(path, method = "GET", body) {
  const res = await fetch(`${API}${path}`, {
    method,
    headers: { "Content-Type": "application/json" },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    let detail = "Request failed";
    try {
      detail = (await res.json()).detail || detail;
    } catch {}
    throw new Error(detail);
  }
  return res.json();
}

export const publishingApi = {
  listConnections: () => req("/connections"),
  connect: (data) => req("/connections", "POST", data),
  disconnect: (id) => req(`/connections/${id}`, "DELETE"),
  createProject: (data) => req("/projects", "POST", data),
  listProjects: () => req("/projects"),
  getProject: (id) => req(`/projects/${id}`),
  updateProject: (id, data) => req(`/projects/${id}`, "PATCH", data),
  ai: (id, tool, context) => req(`/projects/${id}/ai`, "POST", { tool, context }),
  validate: (id) => req(`/projects/${id}/validate`, "POST"),
  build: (id, platform) => req(`/projects/${id}/builds`, "POST", { platform }),
  getBuild: (id) => req(`/builds/${id}`),
  submit: (id, data) => req(`/projects/${id}/submit`, "POST", data),
  submissions: (id) => req(`/projects/${id}/submissions`),
  dashboard: () => req("/dashboard"),
  rejectionAssist: (id, message) => req(`/projects/${id}/rejection-assist`, "POST", { message }),
  resubmit: (subId) => req(`/submissions/${subId}/resubmit`, "POST"),
};

export const APPLE_TRACKS = ["TestFlight", "Submit for Review"];
export const GOOGLE_TRACKS = ["Internal Testing", "Closed Testing", "Open Testing", "Production"];
